import { render, staticRenderFns } from "./SocialLearningDetails.vue?vue&type=template&id=968f50f6&scoped=true&"
import script from "./SocialLearningDetails.vue?vue&type=script&lang=js&"
export * from "./SocialLearningDetails.vue?vue&type=script&lang=js&"
import style0 from "./SocialLearningDetails.vue?vue&type=style&index=0&id=968f50f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968f50f6",
  null
  
)

export default component.exports